<!-- Main Header -->
<nav class="wab-header" *ngIf="!isOrderingHeader">
  <div class="wab-container container-constraint" [ngClass]="{'padding0': !isCollapsed}">
    <div class="navbar-header" #navheader>
      <button aria-label="Open Navigation Menu" type="button" class="pull-left navbar-toggle collapsed" (click)="isCollapsed = !isCollapsed" #navBarButton>
        <div id="navbar-icon-bar" *ngIf="isCollapsed">
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </div>
      </button>
      <div id="navbar-close" *ngIf="!isCollapsed" class="nav-close pointer" [ngClass]="{' guest-user-nav': !(isLoggedIn | async), 'signed-user-nav': (isLoggedIn | async)}" (click)="isCollapsed = !isCollapsed">
        <span>
          <img src="../../../assets/images/navigation/clear-icon.svg" alt="Close Navigation Menu" width="15" height="15"/>
        </span>
      </div>
      <!--desktop view logo-->
        <a tabindex="0" class="navbar-brand hidden-xs hidden-sm visible-md visible-lg" [routerLink]="['/home']">
          <img src="../../../assets/images/navigation/Whataburger-logo.png" alt="Whataburger Home" />
        </a>
      <!-- mobile view menu start-->
      <ng-container *ngIf="isCollapsed">
        <div class="hidden-lg hidden-md visible-sm visible-xs">
          <div class="pull-left">
              <a class="header-xs-logo"[routerLink]="['/home']">
                <img src="../../../assets/images/navigation/whataburger-order-logo.svg" alt="Whataburger Home" class="header-sm-logo-img" />
              </a>
          </div>
          <div class="pull-right">
              <a class="location-icon-xs" href="https://locations.whataburger.com">
                <img src="../../../assets/images/navigation/locations-icon.svg" alt="Browse Whataburger locations"/>
              </a>
            <!-- <button class="btn btn-default btn-sm order-cart-btn"  *ngIf="!hasActiveOrder" [routerLink]="['/ordering/startorder']"> -->
              <button class="btn btn-default btn-sm order-cart-btn"  *ngIf="!hasActiveOrder" (click)="selectPickupMethod()">

              <img  src="../../../assets/images/navigation/bag-icon.svg" alt="Start ordering"/>ORDER
            </button>
            <button class="btn btn-default btn-sm order-cart-btn" *ngIf="hasActiveOrder" (click)="toggleCart()">
              <img [attr.aria-label]="getCartLabel(n)" *ngIf="numberOfItems; let n" alt= "{{getCartLabel(n)}}"  src="../../../assets/images/navigation/bag-icon.svg"/>{{numberOfItems}} Item{{numberOfItems>1 ? 's' : ''}}
            </button>
          </div>
        </div>
      </ng-container>
      <!-- mobile view menu code end-->
      <ng-container  *ngIf="!isCollapsed">
          <div class="guest-head-bg" *ngIf="!(isLoggedIn | async)"></div>
          <div class="signed-head-bg" *ngIf="(isLoggedIn | async)"></div>
          <div class="hidden-lg hidden-md visible-sm visible-xs signin-signup-link">
            <div *ngIf="!(isLoggedIn | async)" class="guest-user">
              <div class="action-button-container">
                <div  tabindex="0" role="button" (click)="showSignInModal();">Sign in</div>
                <span> or </span>
                <div  tabindex="0" role="button" (click)="showSignupModal()" data-toggle="modal"  data-target="#signup-popupModal">Sign up</div>
                <span> to order faster</span>
              </div>
            </div>
            <div *ngIf="(isLoggedIn | async)" class="signed-user">              
                <div class="action-button-container">
                  Hi
                  <div tabindex="0" role="button" (click) = "navigateToAccount()" >{{firstName | async}}!</div>
                </div>
                <div tabindex="0" (click) = "navigateToAccount()" class="action-button-container view-account" role="button">
                  <span>View My Account</span>
                </div>
            </div>
        </div>
      </ng-container>
    </div>


      <!--desktop view menu links -->
      <div id="navbar" class="navbar-collapse collapse hidden-sm hidden-xs visible-md visible-lg" [ngbCollapse]="isCollapsed">
        <div class="row wab-container-row ">
          <div class="col-lg-12 col-md-12 col-sm-12 pull-right hidden-sm hidden-xs visible-md visible-lg pad-0">
              <div class="pull-right">
                <div class="header-location-search">
                    <div class="header-search input-group">
                        <a href="https://locations.whataburger.com" class="location-icon">
                          <img src="../../../assets/images/navigation/top-location-icon.png" alt="Browse Whataburger locations" />
                        </a>
                        <mat-form-field>
                          <input autocomplete="off" aria-label="Find a location near you" matInput placeholder="Find a location near you" class="" [formControl]="searchInput" spellcheck="off" autocorrect="off"
                            autocapitalize="off" type="text" name="searchInput" id="home_search" #home_search>
                          <span matSuffix class="glyphicon glyphicon-search" (click)="onEnter($event)" ></span>
                        </mat-form-field>
                    </div>
                </div>
                <!--right side signin and signup code -->
                <div class="signin-signup-link text-right">
                    <div *ngIf="!(isLoggedIn | async)" class="guest-user">
                      <div class="action-button-container">
                          <div tabindex="0" role="button" (click)="showSignInModal();">Sign In</div>
                          <span> or </span>
                          <div tabindex="0" role="button" (click)="showSignupModal()" >Sign up</div>
                          <span> to order faster</span>
                      </div>
                    </div>
                    <div *ngIf="(isLoggedIn | async)" class="signed-user">
                        <div class="action-button-container">
                          <span>Hi </span>
                          <div tabindex="0" aria-label="View Account" tabindex="0" role="button" class="user-name" [routerLink]="['/account']">{{firstName | async}}!</div>
                          <div tabindex="0" class="signout" role="button" (click)="signOutConfirmation()">Sign Out</div>
                        </div>
                    </div>
                </div>
              </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 hidden-sm hidden-xs visible-md visible-lg pad-0">
            <!--- start ordering button desktop view -->
            <div class="pull-right order-div"  *ngIf="!hasActiveOrder">
              
                <!-- <a class="btn btn-default btn-sm order-cart-btn desktop-view" [routerLink]="['/ordering/startorder']"> -->
                <a role="button" tabindex="0" class="btn btn-default btn-sm order-cart-btn desktop-view" (click)="selectPickupMethod()">
                  <img src="../../../assets/images/navigation/bag-icon.svg" alt="Start ordering" /> START ORDERING
                </a>
              </div>
            <div class="pull-right order-div" *ngIf="hasActiveOrder">
                <button class="btn btn-default btn-sm order-cart-btn desktop-view" (click)="toggleCart()">
                  <img src="../../../assets/images/navigation/bag-icon.svg" *ngIf="numberOfItems; let n" [attr.aria-label]="getCartLabel(n)" alt= "{{getCartLabel(n)}}" /> {{numberOfItems}} Item{{numberOfItems>1 ? 's' : ''}}
                </button>
              </div>
            <ul class="nav navbar-nav wab-nav">
              <li>
                <a [routerLink]="['/locations/menu']" [routerLinkActive]="['active']">MENU
                <span class="bdr-btm"></span>
              </a>
              </li>
              <li *ngIf="loyaltyMode == LoyaltyMode.Points">
                <a (click)="rewardsHeaderClick()" [class.active] ="isActive('rewards')" [routerLinkActive]="['active']" #rla="routerLinkActive">REWARDS
                  <span class="bdr-btm"></span>
                </a>
              </li>
              <li>
                <a routerLink="/careers" [routerLinkActive]="['active']" #rla="routerLinkActive">
                  CAREERS
                  <span class="bdr-btm"></span>
                </a>
              </li>
              <li>
                <a href="https://shop.whataburger.com/" [routerLinkActive]="['active']">
                  WHATASTORE
                  <span class="bdr-btm"></span>
                </a>
              </li>              
              <li>
                <a href="https://stories.whataburger.com/" [routerLinkActive]="['active']">STORIES
                  <span class="bdr-btm"></span>
                </a>
              </li>
              <li>
                <a href="/community" [routerLinkActive]="['active']" [class.active] ="isActive('groupdining')"  class="last-menu-item">COMMUNITY
                  <span class="bdr-btm"></span>
                </a>
              </li>
              <li>
                <a href="/grocery" [routerLinkActive]="['active']">GROCERY
                  <span class="bdr-btm"></span>
                </a>
              </li>
              <!--sub menu of community link start code-->
              <!-- <li class="dropdown ">
                <a href="https://whataburger.com/community/" [routerLinkActive]="['active']"  class="dropdown-toggle last-menu-item" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">COMMUNITY
                  <span class="bdr-btm"></span>
                </a>
                <ul class="dropdown-menu">
                  <li><a href="https://whataburger.com/community/applyforsupport">Apply for Support</a></li>
                  <li><a href="https://stories.whataburger.com/">News & Stories</a></li>
                  <li><a href="https://whataburger.com/community/groupdiningstart/">Group Dining</a></li>
                </ul>
              </li> -->
              <!--sub menu of community link start End-->
            </ul>
          </div>
        </div>
      </div>
        <!--mobile view menu links -->
        <div class="row hidden-lg hidden-md visible-sm visible-xs mobile-view-menu" *ngIf="!isCollapsed">
          <ul class="nav navbar-nav wab-nav-xs-menu" [ngClass]="{' guest-menu': !(isLoggedIn | async), 'signed-menu': (isLoggedIn | async)}">
            <li>
              <!-- <a [routerLink]="['/ordering/startorder']">
                <span><img src="../../../assets/images/navigation/start-ordering-icon.svg" alt="ordering icon"/></span>
                START ORDERING
              </a> -->
              <a role="button" (click)="selectPickupMethod()">
                <span><img src="../../../assets/images/navigation/start-ordering-icon.svg" alt="ordering icon"/></span>
                START ORDERING
              </a>
            </li>
            <li>
              <a [routerLink]="['/locations/menu']" [routerLinkActive]="['active']">
                <span><img src="../../../assets/images/navigation/menu-icon.svg" alt="menu icon"/></span>
                MENU
              </a>
            </li>
            <li *ngIf="loyaltyMode == LoyaltyMode.Points">
              <a (click)="rewardsHeaderClick()" [routerLinkActive]="['active']">
              <span><img src="../../../assets/images/navigation/reward-icon.svg" alt="rewards icon"/></span>
                REWARDS
              </a>
            </li>
            <li>
              <a [routerLink]="['/locations']" [routerLinkActive]="['active']">
                <span><img src="../../../assets/images/navigation/locations-icon.svg" alt="location icon"/></span>
                LOCATION
              </a>
            </li>
            <!-- <li>
              <a href="https://whataburger.com/community/groupdiningstart/" [routerLinkActive]="['active']">
                <span><img src="../../../assets/images/navigation/group-dining-icon.svg" alt="dining icon"/></span>
                GROUP DINING
              </a>
            </li> -->
            <li>
              <a [routerLink]="['/careers']" [routerLinkActive]="['active']" (click)=closeDrawer() [class.active]="isActive('careers')">
                <span><img src="../../../assets/images/navigation/careers-icon.svg" alt="careers icon"/></span>
                CAREERS
              </a>
            </li>
            <li>
              <a href="https://shop.whataburger.com/" [routerLinkActive]="['active']">
                <span><img src="../../../assets/images/navigation/whatastore.svg" alt="whatastore icon"/></span>
                WHATASTORE
              </a>
            </li>            
            <li>
              <a  href="https://stories.whataburger.com/" [routerLinkActive]="['active']">
                <span><img src="../../../assets/images/navigation/stories-icon.svg" alt="stories icon"/></span>
                STORIES
              </a>
            </li>    
            <li>
              <a  class="bdr-none" href='/community' [routerLinkActive]="['active']" [class.active]="isActive('groupdining')">
              <span><img src="../../../assets/images/navigation/community-icon.svg" alt="communtity icon"/></span>
                COMMUNITY
              </a>
            </li>
            <hr/>
            <li class="menu-footer-link">
              <a href="/grocery">
                GROCERY
              </a>
            </li>
            <li class="menu-footer-link">
              <a href="https://stories.whataburger.com/our-history/">
                COMPANY
              </a>
            </li>
            <li class="menu-footer-link">
              <a  [routerLink]="['/franchise']">
                FRANCHISING
              </a>
            </li>
            <li class="menu-footer-link">
              <a href="http://shop.whataburger.com/">
                SHOP WHATASTORE&trade;
              </a>
            </li>
            <li class="menu-footer-link">
              <a [routerLink]="['/online-gift-card/select']">
                Send Online Gift Card
              </a>
            </li>
            <li class="menu-footer-link">
              <a  [routerLink]="['/benefits']">
                EXPLORE ORDERING &amp; REWARDS
              </a>
            </li>
            <li class="menu-footer-link">
              <a   [routerLink]="['/contact-us']">
                CONTACT CUSTOMER CARE
              </a>
            </li>
            <hr/>
            <li  class="signout-link" *ngIf="(isLoggedIn | async)">
              <a role="button" (click)="signOutConfirmation()">
                Sign Out
              </a>
            </li>
          </ul>
        </div>
  </div>
</nav>
<div style="text-align: center">
<app-sub-header></app-sub-header>
</div>
<!-- Order screen header view -->
<nav class="wab-header order-header" *ngIf="isOrderingHeader">
<div class="wab-container header-mobile-view container-constraint">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pad-lft-0">
    <a tabindex="0" role="button" (click)="goBack();" class="back-icon">
      <span class="desktop-view">
          <img alt="Back" class="bck-icon" src="../../../assets/images/navigation/back-caret.png"/>
          <span class="back-link">BACK</span>
      </span>
      <span class="mobile-view">
          <img alt="Back" src="../../../assets/images/navigation/back-arrow.png">
      </span>
    </a>
    <div class="visible-lg visible-md hidden-sm hidden-xs">
        <div class="order-header-logo">
            <a tabindex="0" aria-label="Whataburger Home" class="header-xs-logo"  (click)="navigateToHome()" >
              <img alt="Whataburger Home" src="../../../assets/images/navigation/whataburger-order-logo.svg" />
            </a>
        </div>
    </div>
    <div class="hidden-lg hidden-md visible-sm visible-xs">
        <div class="order-header-logo">
            <a tabindex="0" aria-label="Whataburger Home"  class="header-xs-logo"  (click)="navigateToHome()">
              <img alt="Whataburger Home" src="../../../assets/images/navigation/whataburger-order-logo.svg" />
            </a>
        </div>
    </div>

    <!--cart button-->
    <div>
        <button [attr.aria-label]="getCartLabel(numberOfItems)" class="btn btn-default btn-sm order-cart-btn pull-right" style="position: absolute;right:0" *ngIf="hasActiveOrder && showCartIcon" (click)="toggleCart()">
          <img alt="{{getCartLabel(numberOfItems)}}" src="../../../assets/images/navigation/bag-icon.svg" /> {{numberOfItems}} Item{{numberOfItems>1 ? 's' : ''}}
        </button>
      </div>
  </div>
</div>
</nav>
<app-rewards-nav *ngIf="isRewards"></app-rewards-nav>
